import React from 'react';
import './pillarcard.css';
const Footer = () => {
  return (
    <footer className="footer-container">
      <p className="footer-text">
        © 2025 Chotika | Built with 💻 by DevTeam
      </p>
      <ul className="footer-links">
        <li>
          <a href="#privacy">Privacy Policy</a>
        </li>
        <li>
          <a href="#terms">Terms of Service</a>
        </li>
        <li>
          <a href="#contact">Contact Us</a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;